"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdInsertionConfig = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
function createBaseAdInsertionConfig() {
    return {
        minSnapFromStart: undefined,
        minTimeFromStartSeconds: undefined,
        minStoriesFromStart: undefined,
        minStoriesBeforeEnd: undefined,
        minStoriesBetweenAds: undefined,
        minSnapsBetweenAds: undefined,
        minTimeBetweenAdsSeconds: undefined,
        minSnapsBeforeEnd: undefined,
        minTimeBeforeEndSeconds: undefined,
        minTimeInsertionThresholdSeconds: undefined,
        globalMinSnapsBetweenAds: undefined,
        globalMinTimeBetweenAdsSeconds: undefined,
        maxSnapsNum: undefined,
        conjunctionFromStart: undefined,
        conjunctionBetweenAds: undefined,
        conjunctionBeforeEnd: undefined,
    };
}
exports.AdInsertionConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.minSnapFromStart !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minSnapFromStart }, writer.uint32(10).fork()).ldelim();
        }
        if (message.minTimeFromStartSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.minTimeFromStartSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.minStoriesFromStart !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minStoriesFromStart }, writer.uint32(26).fork()).ldelim();
        }
        if (message.minStoriesBeforeEnd !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minStoriesBeforeEnd }, writer.uint32(34).fork()).ldelim();
        }
        if (message.minStoriesBetweenAds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minStoriesBetweenAds }, writer.uint32(42).fork()).ldelim();
        }
        if (message.minSnapsBetweenAds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minSnapsBetweenAds }, writer.uint32(50).fork()).ldelim();
        }
        if (message.minTimeBetweenAdsSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.minTimeBetweenAdsSeconds }, writer.uint32(58).fork()).ldelim();
        }
        if (message.minSnapsBeforeEnd !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.minSnapsBeforeEnd }, writer.uint32(66).fork()).ldelim();
        }
        if (message.minTimeBeforeEndSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.minTimeBeforeEndSeconds }, writer.uint32(74).fork()).ldelim();
        }
        if (message.minTimeInsertionThresholdSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.minTimeInsertionThresholdSeconds }, writer.uint32(82).fork()).ldelim();
        }
        if (message.globalMinSnapsBetweenAds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.globalMinSnapsBetweenAds }, writer.uint32(90).fork()).ldelim();
        }
        if (message.globalMinTimeBetweenAdsSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.globalMinTimeBetweenAdsSeconds }, writer.uint32(98).fork()).ldelim();
        }
        if (message.maxSnapsNum !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.maxSnapsNum }, writer.uint32(106).fork()).ldelim();
        }
        if (message.conjunctionFromStart !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.conjunctionFromStart }, writer.uint32(114).fork()).ldelim();
        }
        if (message.conjunctionBetweenAds !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.conjunctionBetweenAds }, writer.uint32(122).fork()).ldelim();
        }
        if (message.conjunctionBeforeEnd !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.conjunctionBeforeEnd }, writer.uint32(130).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdInsertionConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minSnapFromStart = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.minTimeFromStartSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.minStoriesFromStart = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.minStoriesBeforeEnd = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.minStoriesBetweenAds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.minSnapsBetweenAds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.minTimeBetweenAdsSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.minSnapsBeforeEnd = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.minTimeBeforeEndSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.minTimeInsertionThresholdSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.globalMinSnapsBetweenAds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.globalMinTimeBetweenAdsSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.maxSnapsNum = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.conjunctionFromStart = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 15:
                    message.conjunctionBetweenAds = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 16:
                    message.conjunctionBeforeEnd = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdInsertionConfig();
        message.minSnapFromStart = object.minSnapFromStart ?? undefined;
        message.minTimeFromStartSeconds =
            object.minTimeFromStartSeconds ?? undefined;
        message.minStoriesFromStart = object.minStoriesFromStart ?? undefined;
        message.minStoriesBeforeEnd = object.minStoriesBeforeEnd ?? undefined;
        message.minStoriesBetweenAds = object.minStoriesBetweenAds ?? undefined;
        message.minSnapsBetweenAds = object.minSnapsBetweenAds ?? undefined;
        message.minTimeBetweenAdsSeconds =
            object.minTimeBetweenAdsSeconds ?? undefined;
        message.minSnapsBeforeEnd = object.minSnapsBeforeEnd ?? undefined;
        message.minTimeBeforeEndSeconds =
            object.minTimeBeforeEndSeconds ?? undefined;
        message.minTimeInsertionThresholdSeconds =
            object.minTimeInsertionThresholdSeconds ?? undefined;
        message.globalMinSnapsBetweenAds =
            object.globalMinSnapsBetweenAds ?? undefined;
        message.globalMinTimeBetweenAdsSeconds =
            object.globalMinTimeBetweenAdsSeconds ?? undefined;
        message.maxSnapsNum = object.maxSnapsNum ?? undefined;
        message.conjunctionFromStart = object.conjunctionFromStart ?? undefined;
        message.conjunctionBetweenAds = object.conjunctionBetweenAds ?? undefined;
        message.conjunctionBeforeEnd = object.conjunctionBeforeEnd ?? undefined;
        return message;
    },
};
//# sourceMappingURL=ad_insertion_config.js.map